import {Button, TextInput} from "omoplay";
import {useEffect, useState} from "react";
import {kakaoProfileChannelAuth, channelAuthorization} from "../../../api/account/account.api";
import GuideButtonFrom from "../GuideButtonFrom";


const KakaoAuthorization = ({disabledAuthButton, isBusiness, channelIdName, showGuide = true, onSubmit}) => {
    const [phoneNumber, setPhoneNumber] = useState("")
    const [authFlag, setAuthFlag] = useState(false)
    const [disabledAuthButtonDisabled, setDisabledAuthButtonDisabled] = useState(false)
    const [authCodeDisabled, setAuthCodeDisabled] = useState(true)
    const [code, setCode] = useState("")

    useEffect(() => {
        setDisabledAuthButtonDisabled(disabledAuthButton)
    }, [disabledAuthButton]);

    const auth = () => {
        kakaoProfileChannelAuth(channelIdName, phoneNumber)
            .then(({data}) => {
                if (data.code !== "200") {
                    alert(data.message)
                } else {
                    setAuthCodeDisabled(false)
                    alert("인증번호가 전송되었습니다. 알림톡을 확인해 주세요.")
                }
            })
    }

    const registration = () => {
        channelAuthorization(channelIdName, phoneNumber, code)
            .then(({data}) => {
                if ((data.code !== "200" && data.code !== "509" && data.code !== "514") || (isBusiness && data.profileKey === null)) {
                    alert(data.message)
                } else {
                    alert("인증 되었습니다.")
                    setAuthCodeDisabled(true)
                    setAuthFlag(true)
                    onSubmit(data.profileKey)
                }
            })
    }

    return (
        <div className="flex-col gap-4">
            {
                showGuide && (
                    <div className="flex-col gap-2">
                        <div>아래의 가이드를 먼저 확인해 주세요 ↓</div>
                        <GuideButtonFrom buttonName="가이드 - 카카오 채널 관리자 인증 방법"
                                         url="https://omoplay.notion.site/NEW-App-25a2d9e7196a809e943ef4c286d0e1ac"
                        />
                    </div>
                )
            }
            <div className="font-medium">카카오 채널 관리자 휴대폰 번호 (필수)</div>
            <div className="flex-center-all gap-2">
                <div className="flex-1">
                    <TextInput placeholder="관리자 휴대폰 번호를 입력하세요"
                               type="numeric"
                               onKeyUp={(e) => {
                                   setPhoneNumber(e.currentTarget.value)
                               }}
                               onKeyDown={(e) => {
                                   setPhoneNumber(e.currentTarget.value)
                               }}
                               disabled={authFlag} />
                </div>
                <div>
                    <Button variants="secondary" value="인증번호 받기" onClick={() => auth()} disabled={disabledAuthButtonDisabled} />
                </div>
            </div>
            <div className="flex-center-all gap-2">
                <div className="flex-1">
                    <TextInput placeholder="인증 번호를 입력하세요"
                               type="numeric"
                               onKeyUp={(e) =>
                                   setCode(e.currentTarget.value)}
                               disabled={authFlag} />
                </div>
                <div>
                    <Button variants="secondary" value="인증 확인" disabled={authCodeDisabled}
                            style={{width: "108px"}}
                            onClick={() => registration()} />
                </div>
            </div>
        </div>
    )
}

export default KakaoAuthorization